import ComplementaryItem from '@components/balance/complementary-item/ComplementaryItem'
import { useAppSelector } from '@store/hooks'
import { selectSelectedProgramComplementaryItem } from '@store/membership/ProgramComplementaryItemReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Flex, Form, Input, InputNumber } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedProgramComplementaryItem())

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item)
    }
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>

      <Flex style={{ marginBottom: 20 }}>
        <ComplementaryItem.Avatar id={item.complementaryItem} />
      </Flex>

      <Form.Item name="quantity" label={'Quantity'} rules={[requiredRule()]}>
        <InputNumber
          mode="spinner"
          style={{ width: '100%' }}
          min={1}
          defaultValue={1}
        />
      </Form.Item>
    </Form>
  )
}

export default Update
